var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2789",
    "data-name": "Group 2789",
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.573,
    height: 92,
    viewBox: "0 0 103.573 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4059",
    "data-name": "Path 4059",
    d: "M-154.3-162.876c7.56,11.3,13.039,22.5,11.564,33.349s-9.878,21.39-21.021,27.08c-11.116,5.664-25,6.454-41.12,2.371-16.121-4.109-34.508-13.066-39.645-27.4-5.11-14.33,3.029-34.008,15.779-46.467,12.75-12.486,30.135-17.781,43.649-14.725C-171.584-185.583-161.891-174.177-154.3-162.876Z",
    transform: "translate(246.072 189.511)",
    fill: "#f5f2fd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(18.672 20.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4101",
    "data-name": "Path 4101",
    d: "M104.036,34.916,85.961,33.24,78.78,16.567a1.448,1.448,0,0,0-2.661,0L68.94,33.24,50.864,34.916a1.448,1.448,0,0,0-.822,2.53L63.68,49.427,59.689,67.136A1.449,1.449,0,0,0,61.841,68.7L77.45,59.432,93.059,68.7a1.448,1.448,0,0,0,2.153-1.564L91.22,49.427l13.638-11.981A1.448,1.448,0,0,0,104.036,34.916Z",
    transform: "translate(-42.851 -15.054)",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2700",
    "data-name": "Group 2700",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4102",
    "data-name": "Path 4102",
    d: "M93.084,11.911c.921,1.28,3.522,6.776,5.009,9.98a.5.5,0,0,1-.8.577c-2.566-2.426-6.954-6.636-7.875-7.916a2.26,2.26,0,0,1,3.667-2.64Z",
    transform: "translate(-76.963 -10.971)",
    fill: "#fab005"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4103",
    "data-name": "Path 4103",
    d: "M360.344,11.911c-.922,1.28-3.522,6.776-5.009,9.98a.5.5,0,0,0,.8.577c2.566-2.426,6.954-6.637,7.875-7.916a2.26,2.26,0,1,0-3.667-2.64Z",
    transform: "translate(-307.267 -10.971)",
    fill: "#fab005"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4104",
    "data-name": "Path 4104",
    d: "M426.244,284.465c-1.5-.489-7.526-1.3-11.03-1.74a.5.5,0,0,0-.306.939c3.091,1.708,8.436,4.608,9.935,5.1a2.26,2.26,0,0,0,1.4-4.3Z",
    transform: "translate(-358.606 -245.993)",
    fill: "#fab005"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4105",
    "data-name": "Path 4105",
    d: "M1.56,284.465c1.5-.489,7.526-1.3,11.03-1.74a.5.5,0,0,1,.306.939c-3.091,1.708-8.436,4.608-9.935,5.1a2.26,2.26,0,0,1-1.4-4.3Z",
    transform: "translate(0 -245.993)",
    fill: "#fab005"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4106",
    "data-name": "Path 4106",
    d: "M239.794,411.137c0-1.577,1.1-7.558,1.766-11.026a.5.5,0,0,1,.988,0c.665,3.468,1.766,9.449,1.766,11.026a2.26,2.26,0,0,1-4.519,0Z",
    transform: "translate(-207.386 -347.165)",
    fill: "#fab005"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarImage);
export default __webpack_public_path__ + "static/media/star-image.b56b99ac941b5cdbe5408587a6d5e6c6.svg";
export { ForwardRef as ReactComponent };